import en from './en/en';
import de from './de/de';

const languages = {
    en,
    de
};

export { languages };
